module.exports = __webpack_public_path__ + "static/media/pic-ht10.b5cef785.jpg";